import { type FC, useState } from "react";
import TextField from "@mui/material/TextField";
import { useSnackbar } from "notistack";
import { ConfirmDialog } from "@/admin/shared/ui";
import { useReissueContractPaymentInvoiceMutation } from "@/admin/entities/billing";

interface ReissueInvoiceDialogProps {
  open: boolean;
  paymentId: string;
  onClose: () => void;
  /** Зовётся после успешной мутации: карточка платежа перезапрашивает себя и список. */
  onCompleted?: () => void;
}

/**
 * Перевыставление счёта требует причину (спека §5): старый номер не
 * пропадает, а переезжает в историю с этой причиной, поэтому поле
 * обязательное, а не опциональная заметка, как у отметки об оплате.
 */
export const ReissueInvoiceDialog: FC<ReissueInvoiceDialogProps> = ({
  open,
  paymentId,
  onClose,
  onCompleted,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const [reason, setReason] = useState("");

  const handleClose = () => {
    setReason("");
    onClose();
  };

  const [reissueInvoice, { loading, error }] =
    useReissueContractPaymentInvoiceMutation({
      onCompleted: () => {
        enqueueSnackbar("Счёт перевыставлен", { variant: "success" });
        handleClose();
        onCompleted?.();
      },
      onError: () => {
        // Ошибку показывает ErrorMessage внутри ConfirmDialog.
      },
    });

  const handleConfirm = () => {
    void reissueInvoice({
      variables: { id: paymentId, reason: reason.trim() },
    });
  };

  return (
    <ConfirmDialog
      open={open}
      onCancel={handleClose}
      onConfirm={handleConfirm}
      confirmTitle="Перевыставить счёт"
      confirmText="Старый номер счёта переедет в историю с указанной причиной."
      loading={loading}
      error={error}
      disabled={!reason.trim()}
    >
      <TextField
        label="Причина"
        value={reason}
        onChange={(event) => setReason(event.target.value)}
        fullWidth
        required
        multiline
        minRows={2}
      />
    </ConfirmDialog>
  );
};
